import { THEMES } from "../themes.js";
import "./ThemePicker.css";

// Groups preserved in definition order: Minimal → Classic → Vibrant → Techy.
const GROUPS = THEMES.reduce((acc, t) => {
  (acc[t.group] ||= []).push(t);
  return acc;
}, {});

export default function ThemePicker({ themeId, onChange }) {
  return (
    <div className="theme-picker">
      <label htmlFor="theme" className="sr-only">
        Choose a colour theme
      </label>
      <span className="theme-icon" aria-hidden="true">🎨</span>
      <select
        id="theme"
        value={themeId}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Colour theme"
      >
        {Object.entries(GROUPS).map(([group, items]) => (
          <optgroup key={group} label={group}>
            {items.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
}
